import { render } from "./WordsDesktop.vue?vue&type=template&id=de3266fe"
import script from "./WordsDesktop.vue?vue&type=script&lang=js"
export * from "./WordsDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/digiworks/SecoursCatholique/Secours-Catholique_Mots_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__